export default __webpack_public_path__ + "static/58-63baabbedf6e707f4f1228aa246f57ea.png";